exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NL2L83vaqDq2XwpSPyy3m {\n  display: grid;\n  grid-template-rows: fit-content(minmax(auto, 100%)) auto auto;\n  text-align: center;\n  margin: 50px 0; }\n  .NL2L83vaqDq2XwpSPyy3m > h2 {\n    color: #0e79b2; }\n  .NL2L83vaqDq2XwpSPyy3m > hr {\n    margin: 0 15%;\n    border: 1px solid #0e79b2;\n    margin-bottom: 15px; }\n  .NL2L83vaqDq2XwpSPyy3m span {\n    font-size: 18px; }\n  .NL2L83vaqDq2XwpSPyy3m > :last-child {\n    margin-top: 50px; }\n", ""]);

// Exports
exports.locals = {
	"section": "NL2L83vaqDq2XwpSPyy3m"
};